import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext(null);

/* Akzentfarben (Neugestaltung 12.10.2026): je Gerät wählbar, Standard P1 Rot. Werte = Farbton, Sättigung, Helligkeit;
   index.css leitet daraus alle Flächen ab (--ah/--as/--al). */
export const AKZENTE = [
  { id: 'rot', name: 'P1 Rot', h: 0, s: '100%', l: '45%' },
  { id: 'wald', name: 'Wald', h: 152, s: '55%', l: '32%' },
  { id: 'ozean', name: 'Ozean', h: 212, s: '80%', l: '45%' },
  { id: 'violett', name: 'Violett', h: 266, s: '62%', l: '50%' },
  { id: 'pink', name: 'Pink', h: 330, s: '81%', l: '52%' },
  { id: 'orange', name: 'Orange', h: 24, s: '92%', l: '46%' },
  { id: 'graphit', name: 'Graphit', h: 220, s: '9%', l: '30%' },
];
const gemerkt = (schluessel, ersatz) => { try { return localStorage.getItem(schluessel) || ersatz; } catch { return ersatz; } };
const merken = (schluessel, wert) => { try { localStorage.setItem(schluessel, wert); } catch { /* ohne Speicher gilt die Wahl bis zum Neuladen */ } };

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => gemerkt('theme', 'light'));
  const [akzent, setAkzent] = useState(() => gemerkt('akzent', 'rot'));

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    merken('theme', theme);
  }, [theme]);

  useEffect(() => {
    const a = AKZENTE.find(x => x.id === akzent) || AKZENTE[0];
    const stil = document.documentElement.style;
    stil.setProperty('--ah', a.h); stil.setProperty('--as', a.s); stil.setProperty('--al', a.l);
    merken('akzent', a.id);
  }, [akzent]);

  const toggleTheme = useCallback(() => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, akzent, setAkzent }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be inside ThemeProvider');
  return ctx;
}
